import React, { Component } from 'react';
import { connect } from 'react-redux';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import Button from '../../UI/Button/Button';
import TextSpinner from '../../UI/TextSpinner/TextSpinner';

import InputMaterial from '../../UI/InputMaterial/InputMaterial';

import * as authActions from '../../../store/actions/index';

class AuthForgotPassword extends Component {

    state = {
        userEmail: ''
    }

    componentWillMount() {
        if (this.props.email !== '') {
            this.setState({
                userEmail: this.props.email
            })
        }
    }

    inputChangeHandler = (event) => {
        this.setState({
            userEmail: event.target.value
        });
    }

    keyPressHandler = (event) => {
        if(event.key === 'Enter') {
            this.props.onForgotPassword(this.state.userEmail);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className={`mb-8 u-phoneTextAlignCenter`}>
                    <HeadingBox>
                        <div className="mb-1">
                            <HeadingH2 size={26} weight="Regular" color="Dark">Forgot Password?</HeadingH2>
                        </div>
                        <HeadingH3 size={13} weight="Regular" color="Light">Simply enter your registered Email ID here &amp; <br/> we'll send you a link to reset password</HeadingH3>
                    </HeadingBox>
                </div>
                <div className={`u-flex justify-content-center align-items-center mb-6 u-height60`}>
                    <InputMaterial type='email' alignment='left' label='Email ID' value={this.state.userEmail} onChange={this.inputChangeHandler} onKeyPress={this.keyPressHandler}/>
                </div>
                <div className={`mb-10 u-flex justify-content-center align-items-center`}>
                    <Button theme='Primary' type='Login' width='Block' onClick={() => this.props.onForgotPassword(this.state.userEmail)}>{this.props.passwordRecoveryLoading ? <TextSpinner type='White'/> : 'SUBMIT'}</Button>
                </div>  
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        email: state.auth.email,
        passwordRecoveryLoading: state.auth.passwordRecoveryLoading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onForgotPassword: (userEmail) => dispatch(authActions.forgotPassword(userEmail))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthForgotPassword);


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthForgotPassword/AuthForgotPassword.js